import { compose } from 'recompose';
import { connect } from 'react-redux';
import { addProps } from 'utils/recompose';
import { modelSubmittedTotal } from 'reducers/models/selectors';
import { locked } from 'reducers/models/selectors';
import { theme, mini } from 'reducers/dashboard/selectors';
import combineSelectors from 'utils/combineSelectors';

export const isSelected = ({ model, selectedModelId }) =>
  model.id === selectedModelId;

export const modelId = ({ model }) => model.id;

export const modelUrl = ({ model }) =>
  `/series/${model.seriesId}/models/${model.id}`;
export const submitted = ({ modelSubmittedTotal }) => {
  return modelSubmittedTotal < 0 ? 0 : modelSubmittedTotal;
};

const mapStateToProps = combineSelectors({
  modelSubmittedTotal,
  locked,
  theme,
  mini,
});

export const selectedModelColor = ({ theme }) => ({
  color: theme.palette.primary,
});

export default compose(
  addProps({ modelId }),
  connect(
    mapStateToProps,
    {},
  ),
  addProps({ isSelected, modelUrl, submitted, selectedModelColor }),
);
